import request from '../NetworkLayer';

import getNonCreatedStatesForOffer from './getNonCreatedStatesForOffer';
import getNonCreatedStatesForPath from './getNonCreatedStatesForPath';

export function getContentInfoWithMissingStates(offerId, offerData) {
  const { offer, states, curriculumOffers } = offerData;
  const nonCreatedStatesForOffer = getNonCreatedStatesForOffer(offer, states);

  const nonCreatedStatesForPaths = [];
  curriculumOffers.forEach((cOffer) => {
    const nonCreatedStatesForCurriculum = getNonCreatedStatesForPath(cOffer, states);
    if (nonCreatedStatesForCurriculum.length < 1) {
      return;
    }

    console.log('nonCreatedStatesForCurriculum are', nonCreatedStatesForCurriculum);
    const curriculumId = cOffer._id;
    nonCreatedStatesForPaths.push(curriculumId);
  });

  const nonCreatedContentInfo = [];
  if (nonCreatedStatesForOffer.length > 0) {
    console.log('nonCreatedStatesForOffer', nonCreatedStatesForOffer);
    nonCreatedContentInfo.push({
      contentId: offerId,
      contentType: 'course'
    });
  }
  nonCreatedStatesForPaths.forEach((pathId) => {
    nonCreatedContentInfo.push({
      contentId: pathId,
      contentType: 'curriculum'
    });
  });

  if (nonCreatedContentInfo.length > 0) {
    console.log('existing stateIds are', states.map(s => s.contentId));
  }

  return nonCreatedContentInfo;
}

export default function fixAnyErrorsInStates(userId, companyId, missingStatesInfo) {
  console.log('missingStateInfo is', missingStatesInfo);
  window.bugsnagClient
    && window.bugsnagClient.notify('MISSING_STATES_FOR_OFFER', {
      metaData: JSON.stringify(missingStatesInfo)
    });

  const fixMissingStatesPayload = {
    type: 'syncLearnerContent',
    syncLearnerContentParams: {
      userId,
      companyId,
      timeStamp: new Date().toISOString(),
      contents: missingStatesInfo
    },
    sync: true
  };

  return request(
    '/syncMutations',
    {
      method: 'POST',
      body: JSON.stringify(fixMissingStatesPayload)
    },
    {
      removeApiEndpoint: true
      // dontSendAuthHeader: true
    }
  );
}
